import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxWallet from '../util/remote/ajaxWallet';

const initialState = { 
    walletListing: null,
    recentTransaction: null,
    transactions: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    quickStats: null,
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const WalletContext = createContext();

export const WalletProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [filters, setFilters] = useState({  
    direction: '',
    payment_type: '',
    ledger_posted: '',
    date_from: '',
    date_to: '', });


 
  const getWallets = async (refresh) => {
    if(Array.isArray(state.walletListing) && !refresh){
      return;
    }
    dispatch({ type: 'walletListing', payload: null });
    const server_response = await ajaxWallet.fetchWallets();
    if(server_response.status === "OK"){
      dispatch({ type: 'walletListing', payload: server_response.details });
    }else{
      dispatch({ type: 'walletListing', payload: '404' });
    }
  }

  const getRecentTransactions = async (refresh) => {
    if(Array.isArray(state.recentTransaction) && !refresh){
      return;
    }
    dispatch({ type: 'recentTransaction', payload: '404' });
    // const server_response = await ajaxWallet.listRecentTransactions();
    // if(server_response.status === "OK"){
    //   dispatch({ type: 'recentTransaction', payload: server_response.details });
    // }else{
    //   dispatch({ type: 'recentTransaction', payload: '404' });
    // }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setMounted = (value) => {
    dispatch({ type: 'mounted', payload: value });
  };


  const getQuickStats = async (refresh) => {
    if(state.quickStats && !refresh) return;
     dispatch({ type: 'quickStats', payload: null });
    // const server_response = await ajaxWallet.fetchCheckingStat();
    // if(server_response.status === "OK"){
    //   dispatch({ type: 'quickStats', payload: server_response.details });
    // }else{
    //   dispatch({ type: 'quickStats', payload: '404' });
    // }
  };

  return(
    <WalletContext.Provider value={{
      ...state,
      filters,
      setMounted, 
      dispatch, 
      getWallets,
      getRecentTransactions,
      setCurrentPage,
      setFilters,
      getQuickStats,
      }}>
      {children}
    </WalletContext.Provider>
  )

}

export const useWallet = ()=>useContext(WalletContext);

